<template>
  <div id="orderDetail">
    <Loading v-if="loading"></Loading>
    <van-form class="content">
      <van-cell-group inset>
        <van-cell @click="showStockSelect">
          <van-field
            autocomplete="off"
            v-model="form.scName"
            name="scName"
            inputmode="none"
            label="仓库"
            :readonly="curType === 'detail'"
            :required="curType !== 'detail'"
        /></van-cell>
        <van-cell @click="showSupplierSelect">
          <van-field
            autocomplete="off"
            v-model="form.supplierName"
            name="supplierName"
            inputmode="none"
            label="供应商"
            :readonly="curType === 'detail'"
            :required="curType !== 'detail'"
        /></van-cell>
        <!-- <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.purchaserName"
            name="purchaserName"
            label="采购员"
            :readonly="curType === 'detail'"
        /></van-cell> -->
      </van-cell-group>
      <van-cell-group inset style="margin-top: 5px">
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.description"
            :readonly="curType === 'detail'"
            rows="1"
            autosize
            label="备注"
            type="textarea"
          />
        </van-cell>
      </van-cell-group>
      <van-form style="margin-top: 5px" class="product-list">
        <div class="flex-between top">
          <div>商品列表</div>
          <div v-if="curType === 'edit'" class="action">
            <Van-icon
              name="add-o"
              type="primary"
              @click="toCategory"
            ></Van-icon>
          </div>
        </div>
        <scroll-list
          height="calc(100vh - 500px)"
          :finished="finished"
          :loading="proLoading"
          :error="error"
          @load="onLoad"
          @search="search"
        >
          <van-cell v-for="(item, i) in form.tableData" :key="item.id">
            <div class="product" @click="toDetail(item)">
              <div class="flex flex-start">
                <div class="tit">{{ item.productName }}</div>
                <div class="price">
                  <span>￥{{ item.purchasePrice }}</span
                  >/{{ item.unit }}
                </div>
              </div>
              <div class="flex flex-end">
                <div class="total">
                  ￥{{ $utils.mul(item.purchasePrice, item.purchaseNum) }}
                </div>
                <div>
                  <span v-if="curType === 'detail'">
                    {{ item.purchaseNum }}{{ item.unit }}</span
                  >
                  <div v-else class="numChangeBox" @click.stop="">
                    <van-icon
                      class="circleIcon"
                      name="minus"
                      @click="minus($event, i, 'purchaseNum')"
                    />
                    <van-field
                      class="numInput"
                      autocomplete="off"
                      type="number"
                      v-model="item.purchaseNum"
                    >
                      <template #right-icon>
                        <span v-if="curType !== 'edit'">
                          {{ item.unit }}
                        </span>
                      </template>
                    </van-field>
                    <van-icon
                      class="circleIcon"
                      name="plus"
                      @click="plus($event, i, 'purchaseNum')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </van-cell>
        </scroll-list>
      </van-form>

      <div style="margin-top: 5px">
        <OrderTimeLine :id="id"></OrderTimeLine>
        <PayType
          ref="payType"
          :type="curType"
          style="margin-top: 5px"
          @payTypeChange="payTypeChange"
          :list="form.tableData2"
        ></PayType>
      </div>
    </van-form>
    <div class="footer">
      <div class="total">
        合计： ￥{{ form.totalAmount }}
        <span
          >品项：<span>{{
            form.tableData && form.tableData.length
          }}</span></span
        >
        <span
          >数量：<span>{{ form.totalNum }}</span></span
        >
      </div>
      <van-cell class="actions-btn">
        <div class="custom-button-group">
          <van-button
            type="info"
            @click="toAction('approvePass')"
            round
            v-if="(status == 0 || status == 6) && curType !== 'edit'"
            :loading="loading"
            v-permission="'purchase:order:approve'"
            >审核通过</van-button
          >
          <van-button
            type="warning"
            @click="toAction('approveRefuse')"
            round
            :loading="loading"
            v-permission="'purchase:order:approve'"
            v-if="(status == 0 || status == 6) && curType !== 'edit'"
            >审核拒绝</van-button
          >
          <van-button
            type="primary"
            @click="toAction('edit')"
            round
            :loading="loading || proLoading"
            v-permission="'purchase:order:modify'"
            v-if="(status == 0 || status == 6) && curType !== 'edit'"
            >修改</van-button
          >
          <van-button
            type="danger"
            @click="toAction('del')"
            round
            v-permission="'purchase:order:delete'"
            :loading="loading"
            v-if="(status == 0 || status == 6) && curType !== 'edit'"
            >删除</van-button
          >
          <van-button
            type="primary"
            @click="toAction('confirm')"
            round
            block
            :loading="loading || proLoading"
            v-if="(status == 0 || status == 6) && curType === 'edit'"
            >保存</van-button
          >
          <van-button
            @click="toAction('close')"
            type="default"
            round
            block
            :loading="loading"
            >关闭</van-button
          >
        </div>
      </van-cell>
    </div>
    <van-dialog
      v-model="approveRefuseVisible"
      title="确认弹窗"
      show-cancel-button
      @cancel="cancelApproveRefuse"
      @confirm="confirmApproveRefuse"
    >
      <van-cell title="确认进行审批拒绝操作？"></van-cell>

      <van-cell v-model="refuseReason">
        <van-field
          autocomplete="off"
          v-model="refuseReason"
          rows="2"
          autosize
          type="textarea"
          label="拒绝理由"
        ></van-field>
      </van-cell>
    </van-dialog>
    <ProductSelect
      type="order"
      columnsType="checkbox"
      :scId="this.form.scId"
      :visible="showProductSelect"
      @confirm="onSelectProductConfirm"
    ></ProductSelect>
    <DateTimePicker
      value-format="yyyy-MM-dd"
      :showPicker="showDatePicker"
      @confirm="onDatePickerConfirm"
      @cancel="showDatePicker = false"
    ></DateTimePicker>
    <StockSelect
      :visible="stockSelectVisible"
      @confirm="stockSelectConfirm"
    ></StockSelect>
    <SupplierSelect
      :visible="supplierSelectVisible"
      @confirm="supplierSelectConfirm"
    ></SupplierSelect>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import Loading from "../../../components/loading.vue";

import CustomTable from "../../../components/customTable.vue";
import OrderTimeLine from "../../../components/orderTimeLine.vue";
import ProductSelect from "../../../components/productSelect.vue";
import DateTimePicker from "../../../components/dateTimePicker.vue";
import StockSelect from "../../../components/stockSelect.vue";
import SupplierSelect from "../../../components/supplierSelect.vue";
import PayType from "../../../components/payType.vue";
import {
  getTextByValue,
  PURCHASE_ORDER_STATUS,
} from "../../../utils/constants";
import {
  get,
  update,
  deleteById,
  approvePass,
  getProducts,
  approveRefuse,
} from "../../../service/api/purchase/order";
import { getOrderTimeLine } from "../../../service/api";
import moment from "moment";

export default {
  name: "index",
  components: {
    CustomTable,
    OrderTimeLine,
    ProductSelect,
    DateTimePicker,
    PayType,
    Loading,
    StockSelect,
    SupplierSelect,
  },
  data() {
    return {
      finished: false,
      proLoading: true,
      error: false,
      supplierSelectVisible: false,
      stockSelectVisible: false,
      loading: true,
      showProductSelect: false,
      showPayTypeSelect: false,
      refuseReason: "",
      approveRefuseVisible: false,
      status: 0,
      curType: "detail",
      brandSelectVisible: false,
      id: this.$route.params.id,
      showDatePicker: false,
      statusList: [
        { text: "启用", value: "1" },
        { text: "停用", value: "0" },
      ],
      columns: [
        {
          field: "productName",
          key: "productName",
          title: "商品名称",
          width: 100,
          fixed: "left",
        },
        {
          field: "productCode",
          key: "productCode",
          title: "商品编号",
          width: 80,
        },

        { field: "unit", key: "unit", title: "单位", width: 80 },
        { field: "spec", key: "spec", title: "规格", width: 80 },
        {
          field: "productionDate",
          key: "productionDate",
          title: "生产日期",
          width: 130,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="productionDate"
                value={text}
                on-click={() => this.openDateTimePicker(rowIndex)}
              ></van-field>
            );
          },
        },
        {
          field: "shelfLifeDays",
          key: "shelfLifeDays",
          title: "保质期时长（天）",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="shelfLifeDays"
                value={text}
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "categoryName",
          key: "categoryName",
          title: "商品类目",
          width: 80,
        },
        { field: "brandName", key: "brandName", title: "商品品牌", width: 80 },
        {
          field: "purchasePrice",
          key: "purchasePrice",
          title: "采购价（元）",
          align: "right",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="purchasePrice"
                value={text}
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
                type="number"
              ></van-field>
            );
          },
        },
        {
          field: "taxCostPrice",
          key: "taxCostPrice",
          title: "含税成本价（元）",
          width: 60,
        },
        { field: "stockNum", key: "stockNum", title: "库存数量", width: 60 },
        {
          field: "taxRate",
          key: "taxRate",
          title: "税率（%）",
          align: "right",
          width: 50,
        },
        {
          field: "isGift",
          key: "isGift",
          title: "是否赠品",
          width: 50,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field] ? "是" : "否";
            return <span>{text}</span>;
          },
        },
        {
          field: "purchaseNum",
          key: "purchaseNum",
          title: "采购数量",
          align: "right",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="purchaseNum"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "purchaseAmount",
          key: "purchaseAmount",
          title: "采购含税金额",
          align: "right",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field];
            return (
              <van-field
                autocomplete="off"
                name="purchaseAmount"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "description",
          key: "description",
          title: "备注",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="description"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "",
          key: "e",
          title: "操作",
          width: "",
          center: "left",
          fixed: "right",
          width: 50,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            return flag ? (
              ""
            ) : (
              <span class="action">
                <van-icon
                  name="delete-o"
                  on-click={() => this.deleteRow(rowIndex)}
                ></van-icon>
              </span>
            );
          },
        },
      ],
      form: {
        id: "",
        name: "",
        retailPrice: "",
        categoryName: "",
        unit: "",
        externalCode: "",
        tableData: [],
        tableData2: [],
        totalAmount: 0,
      },
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      index: 0,
      orderingKey: "purchaseOrdering",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.fullPath && from.fullPath !== "/") {
        vm.previousRoute = from.fullPath;
        localStorage.setItem("previousRoute", from.fullPath);
      } else {
        vm.previousRoute = localStorage.getItem("previousRoute");
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (
      !to.fullPath.includes("ProductModify") &&
      !to.fullPath.includes("/product/category")
    ) {
      localStorage.setItem("orderDetailType", "detail");
    }
    next();
  },
  async mounted() {
    debugger;
    this.curType = localStorage.getItem("orderDetailType") || "detail";
    this.get();
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        if (newVal.tableData && newVal.tableData.length) this.calcSum();
        if (newVal.id)
          localStorage.setItem(this.orderingKey, JSON.stringify(newVal));
      },
      immediate: true,
      deep: true,
    },
    curType(val) {
      localStorage.setItem("orderDetailType", val);
    },
  },
  methods: {
    onLoad() {
      if (this.previousRoute && (this.previousRoute.includes("Modify") || this.previousRoute.includes("/product/category")) && this.curType === "edit") {
        return;
      }
      this.loading = false;
      this.finished = false;
      this.pageIndex++;
      this.getProductList(true);
    },
    search() {
      if (this.previousRoute && (this.previousRoute.includes("Modify") || this.previousRoute.includes("/product/category")) && this.curType === "edit") {
        return;
      }
      debugger;
      this.pageIndex = 1;
      this.loading = false;
      this.finished = false;
      this.getProductList();
    },
    getProductList(flag = false) {
      this.proLoading = true;
      getProducts({
        id: this.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      })
        .then((res) => {
          const tableData = res.data.datas;
          if (flag) {
            this.form.tableData = this.form.tableData ?? [];
            this.form.tableData.push(...tableData);
          } else {
            this.form = Object.assign({}, this.form, { tableData: tableData });
          }
          this.finished = !res.data.hasNext;
        })
        .catch((error) => {
          console.error(error);
          this.error = true;
          this.finished = true;
        })
        .finally(() => {
          this.proLoading = false;
        });
    },
    payTypeChange(payTypeList) {
      const form = Object.assign({}, this.form, { tableData2: payTypeList });
      localStorage.setItem(this.orderingKey, JSON.stringify(form));
    },
    async get() {
      try {
        let data = "";
        if (
          this.previousRoute &&
          (this.previousRoute.includes("Modify") ||
            this.previousRoute.includes("/product/category")) &&
          this.curType === "edit"
        ) {
          this.finished = true;
          this.curType = "edit";
          data = JSON.parse(localStorage.getItem(this.orderingKey) || "{}");
          this.proLoading = false;
        } else {
          this.loading = true;
          const res = await get(this.id);
          data = res.data;
          this.search();
        }
        if (data.status === 3) {
          this.curType = "detail";
        }
        const newForm = Object.assign({}, data, {
          id: data.id,
          scId: data.scId,
          supplierId: data.supplierId,
          purchaserId: data.purchaserId,
          scName: data.scName,
          supplierName: data.supplierName,
          purchaserName: data.purchaserName,
          expectArriveDate: data.expectArriveDate,
          description: data.description,
          status: data.status,
          createBy: data.createBy,
          createTime: data.createTime,
          approveBy: data.approveBy,
          approveTime: data.approveTime,
          refuseReason: data.refuseReason,
          totalNum: data.totalNum,
          giftNum: data.giftNum,
          totalAmount: data.totalAmount,
        });
        this.form = { ...newForm };

        this.form.tableData2 = data.payTypes || [];
        this.status = this.form.status;
        const orderTimeRes = await getOrderTimeLine({ orderId: this.id });
      } catch (error) {
        if (error.isCanceled) return;
        console.error(error);
        this.$router.push("/purchase/order");
        this.loading = false;
      } finally {
        this.loading = false;
        localStorage.setItem(this.orderingKey, JSON.stringify(this.form));
      }
    },
    toCategory() {
      this.$router.push({
        path: "/product/category",
        query: { type: "purchaseOrder" },
      });
    },
    toDetail(item) {
      this.$router.push({
        path: "/purchase/orderProductModify/" + item.productId,
        query: { type: this.curType },
      });
    },
    minus(event, i, key) {
      event.stopPropagation();
      if (!this.form.tableData || !this.form.tableData[i][key]) {
        return;
      }
      let num = Number(this.form.tableData[i][key]) - 1;
      if (num <= 0) {
        this.form.tableData.splice(i, 1);
      } else {
        this.$set(this.form.tableData[i], key, num);
      }
      this.$forceUpdate();
    },
    plus(event, i, key) {
      event.stopPropagation();

      let num = Number(this.form.tableData[i][key]) + 1;
      this.$set(this.form.tableData[i], key, num);
      this.$forceUpdate();
    },
    genParams() {
      const params = {
        id: this.id,
        scId: this.form.scId,
        supplierId: this.form.supplierId,
        purchaserId: this.form.purchaserId,
        expectArriveDate: this.form.expectArriveDate,
        description: this.form.description,
        payTypes: this.$refs.payType.getTableData().map((t) => {
          return {
            id: t.payTypeId,
            payAmount: t.payAmount,
            text: t.text,
          };
        }),
        products: this.form.tableData.map((t) => {
          return {
            productId: t.productId,
            purchasePrice: t.purchasePrice,
            purchaseNum: t.purchaseNum,
            description: t.description,
            productionDate: t.productionDate,
            shelfLifeDays: t.shelfLifeDays,
            shelfLife: this.addDays(t.productionDate, t.shelfLifeDays),
          };
        }),
      };

      return params;
    },

    addDays(date, days) {
      if (!date || !days) {
        return "";
      }
      const result = new Date(date);
      result.setDate(result.getDate() + Number(days));
      return moment(result).format("YYYY-MM-DD");
    },
    showStockSelect() {
      if (this.curType != "detail") this.stockSelectVisible = true;
    },
    stockSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.stockSelectVisible = false;
        return;
      }
      this.stockSelectVisible = false;
      this.form.scName = row.name;
      this.form.scId = row.id;
    },
    showSupplierSelect() {
      if (this.curType != "detail") this.supplierSelectVisible = true;
    },
    supplierSelectConfirm(row) {
      if (Object.keys(row).length === 0) {
        this.supplierSelectVisible = false;
        return;
      }
      this.supplierSelectVisible = false;
      this.form.supplierName = row.name;
      this.form.supplierId = row.id;
    },
    inputChange(rowIndex, field, val) {
      this.$set(this.form.tableData, rowIndex, {
        ...this.form.tableData[rowIndex],
        [field]: val,
      });
    },
    onDatePickerConfirm(val) {
      val
        ? this.$set(this.form.tableData, this.index, {
            ...this.form.tableData[this.index],
            productionDate: val,
          })
        : "";
      this.showDatePicker = false;
      this.index = 0;
    },
    openDateTimePicker(index) {
      this.showDatePicker = true;
    },
    // 创建/修改订单校验数据
    validData() {
      if (this.$utils.isEmpty(this.form.scId)) {
        this.$utils.createError("仓库不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.supplierId)) {
        this.$utils.createError("供应商不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.expectArriveDate)) {
        this.$utils.createError("预计到货日期不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.tableData)) {
        this.$utils.createError("请录入商品！");
        return false;
      }

      for (let i = 0; i < this.form.tableData.length; i++) {
        const product = this.form.tableData[i];

        if (this.$utils.isEmpty(product.productId)) {
          this.$utils.createError("第" + (i + 1) + "行商品不允许为空！");
          return false;
        }

        if (this.$utils.isEmpty(product.purchasePrice)) {
          this.$utils.createError("第" + (i + 1) + "行商品采购价不允许为空！");
          return false;
        }
        // if (this.$utils.isEmpty(product.productionDate)) {
        //   this.$utils.createError('第' + (i + 1) + '行商品生产日期不允许为空！');
        //   return false;
        // }
        // if (this.$utils.isEmpty(product.shelfLifeDays)) {
        //   this.$utils.createError('第' + (i + 1) + '行商品保质期不允许为空！');
        //   return false;
        // }
        if (!this.$utils.isFloat(product.purchasePrice)) {
          this.$utils.createError("第" + (i + 1) + "行商品采购价必须为数字！");
          return false;
        }

        if (product.isGift) {
          if (parseFloat(product.purchasePrice) !== 0) {
            this.$utils.createError("第" + (i + 1) + "行商品采购价必须等于0！");
            return false;
          }
        } else {
          if (!this.$utils.isFloatGtZero(product.purchasePrice)) {
            this.$utils.createError("第" + (i + 1) + "行商品采购价必须大于0！");
            return false;
          }
        }

        if (!this.$utils.isNumberPrecision(product.purchasePrice, 2)) {
          this.$utils.createError(
            "第" + (i + 1) + "行商品采购价最多允许2位小数！"
          );
          return false;
        }

        if (!this.$utils.isTotalNumGtZero(product.purchaseNum)) {
          this.$utils.createError(
            "第" + (i + 1) + "行商品采购数量必须大于0并且最多三位小数！"
          );
          return false;
        }
      }
      if (!this.$refs.payType.validData()) {
        return false;
      }
      if (!this.validatePayTypeAmount()) {
        this.$utils.createError(
          "所有约定支付的支付金额不等于含税总金额，请检查！"
        );
        return false;
      }

      return true;
    },
    validatePayTypeAmount() {
      const data = this.$refs && this.$refs.payType.getTableData();

      if (data.length <= 0) {
        return false;
      } else {
        const payTypeAmount = data.reduce((pre, cur) => {
          return pre + Number(cur.payAmount);
        }, 0);

        return payTypeAmount == this.form.totalAmount;
      }
    },
    calcSum() {
      let totalNum = 0;
      let giftNum = 0;
      let totalAmount = 0;

      this.form.tableData
        .filter((t) => {
          return (
            this.$utils.isFloatGeZero(t.purchasePrice) &&
            this.$utils.isFloatGtZero(t.purchaseNum)
          );
        })
        .forEach((t) => {
          const num = parseFloat(t.purchaseNum);
          if (t.isGift) {
            giftNum = this.$utils.add(giftNum, num);
          } else {
            totalNum = this.$utils.add(totalNum, num);
          }
          totalAmount = this.$utils.add(
            totalAmount,
            this.$utils.mul(num, t.purchasePrice)
          );
        });

      this.form.totalNum = totalNum;
      this.form.giftNum = giftNum;
      this.form.totalAmount = totalAmount;
    },
    onSelectProductConfirm(row) {
      if (this.showProductSelect) {
        this.showProductSelect = false;
      }
      if (row.length) {
        row.forEach((el) => {
          this.form.tableData.push({
            ...el,
          });
        });
      }
    },
    deleteRow(index) {
      this.form.tableData.splice(index, 1);
    },
    confirmApproveRefuse() {
      this.loading = true;
      approveRefuse({
        id: this.id,
        refuseReason: this.refuseReason,
      })
        .then((res) => {
          Toast.success(res.msg);
          this.$router.push({ path: "/purchase/order" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelApproveRefuse() {
      this.loading = false;
      this.approveRefuseVisible = false;
      this.refuseReason = "";
    },

    formatter(val) {
      return isNaN(val) ? val : getTextByValue(PURCHASE_ORDER_STATUS, val);
    },
    async toAction(action) {
      let promise = null;
      if (action === "close") {
        if (this.curType === "edit") {
          this.curType = "detail";
          return;
        } else this.$router.push({ path: "/purchase/order" });
      } else if (action === "edit") {
        this.curType = "edit";
        return;
      } else if (action === "confirm") {
        //修改校验  todo
        if (!this.validData()) return;
        this.loading = true;

        const params = this.genParams();
        update(params)
          .then((res) => {
            Toast.success(res.msg);
            this.$router.push({ path: "/purchase/order" });
          })
          .catch(() => {
            Toast.fail("出错啦");
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (action === "del") {
        this.loading = true;

        Dialog.confirm({
          title: "确认弹窗",
          message: "确定要删除该采购订单吗",
        })
          .then(async () => {
            promise = await deleteById({ id: this.id });
            Toast.success(promise.msg);
            this.$router.push({ path: "/purchase/order" });
          })
          .catch(() => {
            Toast.fail(promise.msg);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (action === "approvePass") {
        this.loading = true;

        Dialog.confirm({
          title: "确认弹窗",
          message: "确定要进行审批通过操作",
        })
          .then(async () => {
            promise = await approvePass({
              id: this.id,
            });
            Toast.success(promise.msg);
            this.$router.push({ path: "/purchase/order" });
          })
          .catch(() => {
            Toast.fail(promise.msg);
          })
          .catch(() => {
            Toast.fail("出错啦");
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (action === "approveRefuse") {
        this.approveRefuseVisible = true;
      }
    },
  },
};
</script>
<style scoped lang="less">
.van-cell-group--inset {
  margin: 0px;
  border-radius: 0px;
}
.van-cell {
  padding: 3px 3px 3px 15px;
}
#orderDetail {
  position: relative;
  height: calc(100vh - 70px);
  overflow: auto;
}
::v-deep .van-field__body {
  height: 100%;
}
.content {
  .product-list {
    background-color: #fff;
    max-height: 60vh;
    overflow: auto;
    .top {
      background-color: #fff;
      padding: 10px;
      font-size: 16px;
    }
    .action {
      background-color: #fff;
      padding-left: 20px;
      display: flex;
      align-items: center;
      font-size: 26px;
      height: 36px;
    }
    .list-con {
      max-height: 300px;
      overflow: auto;
    }
  }
}
.footer {
  z-index: 9999;
  width: 100%;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  .total {
    color: red;
    font-weight: 600;
    span {
      margin-left: 8px;
      color: #5e5b5b;
      font-size: 13px;
      span {
        color: #3b7f61;
      }
    }
  }
  .actions-btn {
    &.van-cell {
      padding: 0px;
    }
    .van-button {
      max-width: 95px;
      padding: 3px 6px;
    }
  }
}

.action {
  background-color: #fff;
  padding-left: 20px;
  display: flex;
  align-items: center;
  font-size: 26px;
  height: 36px;
}
.product {
  padding-right: 8px;
  font-size: 14px;
  color: #999;
  display: flex;
  width: 100%;
  justify-content: space-between;

  .flex {
    display: flex;
    justify-items: center;
    flex-direction: column;
    align-content: flex-start;
    justify-content: center;
    align-items: flex-start;
  }
  .flex-end {
    align-items: flex-end;
  }
  .tit {
    max-width: 230px;
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
  .price span {
    font-weight: 500;
    color: #347f5e;
  }
  .total {
    font-weight: 600;
    color: red;
  }
}
.van-cell-group--inset {
  margin: 0px;
  border-radius: 0px;
}
</style>
